/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'organization-file-category-new-each': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M18.125 6.25H15V7.5h3.125v3.75H13.75v1.25h1.875v1.339a2.5 2.5 0 101.25 0V12.5h1.25a1.252 1.252 0 001.25-1.25V7.5c0-.69-.56-1.25-1.25-1.25zm-.625 10a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zm-5.625-12.5H8.75V5h3.125v3.75H7.5V10h1.875v3.839a2.5 2.5 0 101.25 0V10h1.25c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25zm-.625 12.5a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zm-5.625-15h-3.75c-.69 0-1.25.56-1.25 1.25v3.75c0 .69.56 1.25 1.25 1.25h1.25v6.339a2.5 2.5 0 101.25 0V7.5h1.25c.69 0 1.25-.56 1.25-1.25V2.5c0-.69-.56-1.25-1.25-1.25zM5 16.25a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zm-3.125-10V2.5h3.75l.001 3.75H1.875z"/>'
  }
})
